require('./app');
let SnazzyInfoWindow = require('snazzy-info-window');

$(function () {
    if ($('#property-listings').length) {

        console.log('Property Listings');

        $('.dropdown-menu').on('click', function (e) { e.stopPropagation(); });

        let properties = window.properties,
            propertiesLength = Object.keys(properties).length,
            propertyListingsContainer = $('#property-listings-container'),
            locationSearchSelect = $('#location-search-select'),
            locationSearchSelectHasBeenFormatted = false,
            locationSearchClearContainer = $('#location-search-select-container'),
            typeSearchSelect = $('#type-search-select'),
            typeSearchClearContainer = $('#type-search-select-container'),
            priceSearchSlider = $('#price-search-slider'),
            priceSearchLowInput = $('#price-search-low'),
            priceFilterLabel = $('#price-filter-label'),
            priceSearchHighInput = $('#price-search-high'),
            acresSearchSlider = $('#acres-search-slider'),
            acresSearchLowInput = $('#acres-search-low'),
            acresSearchHighInput = $('#acres-search-high'),
            acresFilterLabel = $('#acreage-filter-label'),
            searchMinAcres = 0,
            searchMaxAcres = parseInt(acresSearchHighInput.val()) + 100,
            forSaleCheck = $('#for-sale-check'),
            forAuctionCheck = $('#for-auction-check'),
            soldCheck = $('#sold-check'),
            pastAuctionCheck = $('#past-auction-check'),
            newPropertiesCheck = $('#new-properties-check'),
            recentlyAddedDaysCount = 0,
            recentlyReducedCheck = $('#recently-reduced-check'),
            recentlyReducedDaysCount = 0,
            searchQueryInput = $('#search-query'), // no longer in use
            searchPropertyNameQueryInput = $('#search-property-name-query'),
            searchSortButtons = $('.search-sort-button'),
            morePropertiesButton = $('#more-properties-button'),
            searchMaxPrice = parseInt(priceSearchHighInput.val()) + 100,
            searchMinPrice = 0,
            viewingCount = 16,
            viewingCountIncrement = 16,
            title = document.getElementsByTagName("title")[0].innerHTML,
            initialSearchDone = false,
            adjustingParams = false,
            sortAscending = true,
            setSortType = '',
            justSetToFeatured = false,
            isFiltering = false,
            filtering = {
                location: false,
                price: false,
                type: false,
                acreage: false,
                status: {
                    for_sale: false,
                    for_auction: false,
                    sold: false,
                    past_auction: false,
                    new: false,
                    recent: false,
                    reduced: false
                }
            },
            currentPropertiesId = [],
            navViewMenuToggle = $('#view-as-nav-item .dropdown-toggle'),
            navViewLabel = $('#viewing-label'),
            navViewItems = $('.search-view-button'),
            navViewButton = $('.nav-view'),
            sortingLabel = $('#sorting-label'),
            noResultsContainer = $('#property-no-results-container'),
            resetSearchNavItem = $('#reset-search-nav-item'),
            saveSearchNavItem = $('#save-search-nav-item'),
            urlSetState = $('#url-set-state'),
            urlSetType = $('#url-set-type'),
            showAnyPriceCheckbox = $('#show-any-price'),
            acresSearchToggleCheckbox = $('#acres-search-toggle'),
            clearMoreOptionsButton = $('#clear-more-options-button'),
            filterBarLoading = $('#filter-bar-loading-overlay'),
            listingsViewLoading = $('#listings-view-loading-overlay'),
            searchResetButtons = $('.search-reset-button'),
            displayType = 'list',
            mapProperties = [];

        if($(window).width() > 1800) {
            viewingCount = 20;
            viewingCountIncrement = 20;
        }

        var t;

        // Update the scroll position url parameter, set to debounce
        document.addEventListener('scroll', function (event) { clearTimeout(t); checkScroll(); }, true);
        function checkScroll() { t = setTimeout(function () { window.helpers.updateUrl('scroll_position', $(window).scrollTop()); }, 500); }

        // Search reset buttons, clear all filter settings and trigger search
        searchResetButtons.on('click', function (e) {
            let redirectLocation = $(this).attr('href');
            e.preventDefault();
            window.helpers.eraseCookie('user-last-set-location');
            window.helpers.eraseCookie('user-last-set-type');
            window.helpers.eraseCookie('user-last-set-price-min');
            window.helpers.eraseCookie('user-last-set-price-max');
            window.helpers.eraseCookie('user-last-set-acres-min');
            window.helpers.eraseCookie('user-last-set-acres-max');
            window.helpers.eraseCookie('user-last-set-search-acres');
            window.helpers.eraseCookie('user-last-set-search-price');
            window.helpers.eraseCookie('user-last-set-for-sale');
            window.helpers.eraseCookie('user-last-set-for-auction');
            window.helpers.eraseCookie('user-last-set-is-sold');
            window.helpers.eraseCookie('user-last-set-past-auction');
            // window.helpers.eraseCookie('user-last-set-sort');
            window.helpers.eraseCookie('user-last-set-recently-added-days');
            window.helpers.eraseCookie('user-last-set-recently-reduced-days');
            window.location.href = redirectLocation;
        });

        // Map / Grid Toggle
        navViewButton.on('click', function () {
            if ($(this).hasClass('is-map')) { triggerMapView(); } else { triggerGridView(); }
        });

        // Map / Grid Toggle
        navViewItems.on('click', function () {
            if ($(this).data('view-type') === "list") { triggerGridView(); } else { triggerMapView(); }
        });

        /**
         * Adjust the necessary things to show the Map View
         */
        function triggerMapView() {
            displayType = 'map';
            $('#property-grid-view').addClass('d-none');
            $('#property-map-view').removeClass('d-none');
            $('#sort-by-nav-item-container').addClass('hiding');
            $('#reset-search-nav-item a').attr('href', window.property_listings_link + '?view_type=map');

            if($(window).width() > 1200) {
                navViewMenuToggle.addClass('is-map').removeClass('is-list');
                navViewLabel.html('Map');
            } else {
                navViewButton.addClass('is-list').removeClass('is-map');
                navViewButton.html('List View');
                $('.filter-header .sort-dropdown').css('opacity', 0);
            }

            $('#sort-by-nav-item a').attr('tabindex', -1);

            window.helpers.gaEvent('Property Search', 'view-chosen', 'map');
            window.helpers.createOrUpdateCookie('user-last-set-view', 'map', 60);
            window.helpers.updateUrl('view_type', 'map');
            propertySearch();
            lazyLoadPropertyImages();
        }

        /**
         * Adjust the necessary things to show the Grid View
         */
        function triggerGridView() {
            displayType = 'list';
            $('#property-grid-view').removeClass('d-none');
            $('#property-map-view').addClass('d-none');
            $('#sort-by-nav-item-container').removeClass('hiding').removeClass('d-none');
            $('#reset-search-nav-item a').attr('href', window.property_listings_link);

            if($(window).width() > 1200) {
                navViewMenuToggle.removeClass('is-map').addClass('is-list');
                navViewLabel.html('List');
            } else {
                navViewButton.removeClass('is-list').addClass('is-map');
                navViewButton.html('Map View');
                $('.filter-header .sort-dropdown').css('opacity', 1);
            }

            $('#sort-by-nav-item a').attr('tabindex', '');

            window.helpers.gaEvent('Property Search', 'view-chosen', 'grid');
            window.helpers.createOrUpdateCookie('user-last-set-view', 'grid', 60);
            window.helpers.updateUrl('view_type', 'grid');
            propertySearch();
            lazyLoadPropertyImages();
        }


        locationSearchSelect.on('shown.bs.select', function () {
            if (!locationSearchSelectHasBeenFormatted) {
                var locationRegionHeadings = $('#location-search-select-container').find('.list-col-group-heading');
                locationRegionHeadings.each(function () {
                    $(this).parent('li').addClass('optgroup-heading');
                    $(this).append('<span class="select-all-right">Select Region</span>');
                });

                if (locationSearchSelect.val() == null) {
                    $('#location-search-select-container').find('.dropdown-menu').append('<div class="disabled location-apply-button">Search</div>');
                } else {
                    $('#location-search-select-container').find('.dropdown-menu').append('<div class="location-apply-button">Search</div>');
                }

                locationSearchSelectHasBeenFormatted = true;
            }
        });

        // This is the initial trigger of the search, once the locations dropdown has been generated, trigger the start of the search
        locationSearchSelect.on('loaded.bs.select', function () { checkInitialSearchParams(); });

        $('.price-apply-button').on('click', function () { $('#price-dropdown-toggle').click(); });

        $('.more-options-apply').on('click', function () { $('.more-options-dropdown').click(); });


        // START: Price Slider Controls and Settings
        let priceLowValue = 0,
            priceHighValue = searchMaxPrice;

        if (window.helpers.getQueryVariable('price_max')) {
            priceHighValue = window.helpers.getQueryVariable('price_max');
            filtering.price = true;
        } else {
            priceHighValue = searchMaxPrice;
        }
        if (window.helpers.getQueryVariable('price_min')) {
            priceLowValue = window.helpers.getQueryVariable('price_min');
            filtering.price = true;
        } else {
            priceLowValue = searchMinPrice;
        }

        priceSearchSlider.slider({
            range: true,
            min: 0,
            max: priceSearchHighInput.val(),
            step: 10000,
            values: [priceLowValue, priceHighValue],
            slide: function (event, ui) {

                searchMinPrice = ui.values[0];
                searchMaxPrice = ui.values[1];
                filtering.price = true;

                $('#price-search-slider .ui-slider-handle:eq(0) .price-range-min').html('$' + window.helpers.nFormatter(ui.values[0], 0));
                if (window.helpers.nFormatter(ui.values[1], 0) === "50M") {
                    $('#price-search-slider .ui-slider-handle:eq(1) .price-range-max').html('$' + window.helpers.nFormatter(ui.values[1], 0) + '+');
                } else {
                    $('#price-search-slider .ui-slider-handle:eq(1) .price-range-max').html('$' + window.helpers.nFormatter(ui.values[1], 0));
                }
                $('.price-range-both').html('<i>$' + window.helpers.nFormatter(ui.values[0], 1) + ' - </i>$' + window.helpers.nFormatter(ui.values[1], 0));

                if (ui.values[0] === ui.values[1]) {
                    $('.price-range-both i').css('display', 'none');
                } else {
                    $('.price-range-both i').css('display', 'inline');
                }

                if (window.helpers.collision($('.price-range-min'), $('.price-range-max'))) {
                    $('.price-range-min, .price-range-max').css('opacity', '0');
                    $('.price-range-both').css('display', 'block');
                } else {
                    $('.price-range-min, .price-range-max').css('opacity', '1');
                    $('.price-range-both').css('display', 'none');
                }

            }, stop: function (event, ui) {

                filtering.price = true;
                window.helpers.updateUrl('price_min', searchMinPrice);
                window.helpers.updateUrl('price_max', searchMaxPrice);
                showAnyPriceCheckbox.attr('checked', false);
                window.helpers.updateUrl('search_prices', 'no');

                window.helpers.createOrUpdateCookie('user-last-set-price-min', searchMinPrice, 60);
                window.helpers.createOrUpdateCookie('user-last-set-price-max', searchMaxPrice, 60);
                window.helpers.createOrUpdateCookie('user-last-set-search-prices', 'no', 60);

                if (window.helpers.nFormatter(ui.values[1], 0) === "50M") {
                    priceFilterLabel.html('$' + window.helpers.nFormatter(ui.values[0], 1) + ' - ' + '$' + window.helpers.nFormatter(ui.values[1], 0) + '+');
                } else {
                    priceFilterLabel.html('$' + window.helpers.nFormatter(ui.values[0], 1) + ' - ' + '$' + window.helpers.nFormatter(ui.values[1], 0));
                }

                propertySearch();

            }, change: function (event, ui) {

                $('#price-search-slider .ui-slider-handle:eq(0) .price-range-min').html('$' + window.helpers.nFormatter(ui.values[0], 0));
                if (window.helpers.nFormatter(ui.values[1], 0) === "50M") {
                    $('#price-search-slider .ui-slider-handle:eq(1) .price-range-max').html('$' + window.helpers.nFormatter(ui.values[1], 0) + '+');
                } else {
                    $('#price-search-slider .ui-slider-handle:eq(1) .price-range-max').html('$' + window.helpers.nFormatter(ui.values[1], 0));
                }
                $('.price-range-both').html('<i>$' + window.helpers.nFormatter(ui.values[0], 1) + ' - </i>$' + window.helpers.nFormatter(ui.values[1], 0));

            }
        });

        // Price Slider Initial Labels Set
        $('#price-search-slider .ui-slider-range').append('<span class="price-range-both value"><i style="display: none;">$' + window.helpers.nFormatter(parseInt(priceSearchSlider.slider('values', 0)), 1) + ' - </i>' + window.helpers.nFormatter(parseInt(priceSearchSlider.slider('values', 1)), 1) + '</span>');
        $('#price-search-slider .ui-slider-handle:eq(0)').append('<span class="price-range-min value">$' + window.helpers.nFormatter(parseInt(priceSearchSlider.slider('values', 0)), 1) + '</span>');
        if (window.helpers.nFormatter(parseInt(priceSearchSlider.slider('values', 1)), 1) === "50M") {
            $('#price-search-slider .ui-slider-handle:eq(1)').append('<span class="price-range-max value">$' + window.helpers.nFormatter(parseInt(priceSearchSlider.slider('values', 1)), 1) + '+</span>');
        } else {
            $('#price-search-slider .ui-slider-handle:eq(1)').append('<span class="price-range-max value">$' + window.helpers.nFormatter(parseInt(priceSearchSlider.slider('values', 1)), 1) + '</span>');
        }

        if (window.helpers.nFormatter(parseInt(priceSearchSlider.slider('values', 1)), 1) === "50M" && parseInt(window.helpers.nFormatter(parseInt(priceSearchSlider.slider('values', 0)), 1)) === 0) {
            // priceFilterLabel.html('$' + window.helpers.nFormatter(ui.values[ 0 ], 1) + ' - ' + '$' + window.helpers.nFormatter(ui.values[ 1 ], 0) + '+');
        } else {
            priceFilterLabel.html('$' + window.helpers.nFormatter(parseInt(priceSearchSlider.slider('values', 0)), 1) + ' - ' + '$' + window.helpers.nFormatter(parseInt(priceSearchSlider.slider('values', 1)), 0));
        }
        // END: Price Slider Controls and Settings


        // START: Acres Slider Controls and Settings
        var acresLowValue = 0,
            acresHighValue = 0;

        if (window.helpers.getQueryVariable('acres_max')) {
            acresHighValue = window.helpers.getQueryVariable('acres_max');
            filtering.acreage = true;
        } else {
            acresHighValue = acresSearchHighInput.val();
        }

        if (window.helpers.getQueryVariable('acres_min')) {
            acresLowValue = window.helpers.getQueryVariable('acres_min');
        } else {
            acresLowValue = acresSearchLowInput.val();
            searchMinAcres = acresLowValue;
        }

        acresSearchSlider.slider({
            range: true,
            min: 0,
            max: parseInt(acresSearchHighInput.val()),
            step: 500,
            values: [acresLowValue, acresHighValue],
            slide: function (event, ui) {

                searchMinAcres = ui.values[0];
                searchMaxAcres = ui.values[1];

                $('#acres-search-slider .ui-slider-handle:eq(0) .acres-range-min').html(window.helpers.nFormatter(ui.values[0], 1));
                if (window.helpers.nFormatter(ui.values[1], 1) === "50k") {
                    $('#acres-search-slider .ui-slider-handle:eq(1) .acres-range-max').html(window.helpers.nFormatter(ui.values[1], 1) + '+');
                } else {
                    $('#acres-search-slider .ui-slider-handle:eq(1) .acres-range-max').html(window.helpers.nFormatter(ui.values[1], 1));
                }

                if (ui.values[0] === ui.values[1]) {
                    $('.acres-range-both i').css('display', 'none');
                } else {
                    $('.acres-range-both i').css('display', 'inline');
                }

                if (window.helpers.collision($('.acres-range-min'), $('.acres-range-max')) == true) {
                    $('.acres-range-min, .acres-range-max').css('opacity', '0');
                    $('.acres-range-both').css('display', 'block');
                } else {
                    $('.acres-range-min, .acres-range-max').css('opacity', '1');
                    $('.acres-range-both').css('display', 'none');
                }

            }, stop: function (event, ui) {

                filtering.acreage = (((parseInt(acresLowValue) !== parseInt(searchMinAcres)) && acresSearchToggleCheckbox.is(':checked')) || ((parseInt(acresHighValue) !== parseInt(searchMaxAcres)) && acresSearchToggleCheckbox.is(':checked') ));

                window.helpers.updateUrl('acres_min', searchMinAcres);
                window.helpers.updateUrl('acres_max', searchMaxAcres);

                if (acresSearchToggleCheckbox.is(':checked')) { propertySearch(); } else { clearMoreOptionsCheck(); }

            }, change: function (event, ui) {
                $('#acres-search-slider .ui-slider-handle:eq(0) .acres-range-min').html(window.helpers.nFormatter(ui.values[0], 1));
                if (window.helpers.nFormatter(ui.values[1], 1) === "50k") {
                    $('#acres-search-slider .ui-slider-handle:eq(1) .acres-range-max').html(window.helpers.nFormatter(ui.values[1], 1) + '+');
                    if (window.helpers.nFormatter(ui.values[0], 1) === "0") {
                        acresFilterLabel.html('Any Acreage');
                    } else {
                        acresFilterLabel.html(window.helpers.nFormatter(ui.values[0], 1) + ' - ' + window.helpers.nFormatter(ui.values[1], 1) + '+');
                    }
                } else {
                    $('#acres-search-slider .ui-slider-handle:eq(1) .acres-range-max').html(window.helpers.nFormatter(ui.values[1], 1));
                    acresFilterLabel.html(window.helpers.nFormatter(ui.values[0], 1) + ' - ' + window.helpers.nFormatter(ui.values[1], 1));
                }
                $('.acres-range-both').html('<i>' + window.helpers.nFormatter(ui.values[0], 1) + ' - </i>' + window.helpers.nFormatter(ui.values[1], 1));
            }
        });

        // Acres Slider Initial Labels Set
        $('#acres-search-slider .ui-slider-range').append('<span class="acres-range-both value"><i style="display: none;">' + window.helpers.nFormatter(parseInt(acresSearchSlider.slider('values', 0)) + ' - </i>' + parseInt(acresSearchSlider.slider('values', 1)), 1) + '</span>');
        $('#acres-search-slider .ui-slider-handle:eq(0)').append('<span class="acres-range-min value">' + window.helpers.nFormatter(parseInt(acresSearchSlider.slider('values', 0)), 1) + '</span>');
        if (window.helpers.nFormatter(acresSearchSlider.slider('values', 1), 1) === "50k") {
            $('#acres-search-slider .ui-slider-handle:eq(1)').append('<span class="acres-range-max value">' + window.helpers.nFormatter(parseInt(acresSearchSlider.slider('values', 1)), 1) + '+</span>');
        } else {
            $('#acres-search-slider .ui-slider-handle:eq(1)').append('<span class="acres-range-max value">' + window.helpers.nFormatter(parseInt(acresSearchSlider.slider('values', 1)), 1) + '</span>');
        }
        // END: Acres Slider Controls and Settings


        // Save Search Confirm Button
        $('#save-search-confirm-button').on('click', function () {

            window.helpers.gaEvent('Property-search', 'search-saved', '');

            var searchUrl = window.location.href,
                searchName = $('#save-search-name').val(),
                searchDescription = $('#save-search-description').val(),
                userId = $('#current-user-id').val();

            if (searchName === "") {
                $('#save-search-form-error').removeClass('d-none');
            } else {
                $('#save-search-form-error').addClass('d-none');
                $.post("/wp/wp-admin/admin-ajax.php", {
                    'action': 'save_property_search',
                    'user_id': userId,
                    'searchUrl': searchUrl,
                    'searchName': searchName,
                    'searchDescription': searchDescription,
                    'currentIds': currentPropertiesId
                }, function (data) {
                    $('#save-search-modal').modal('hide');
                    $('#save-search-name').val('');
                    $('#save-search-description').val('');

                    $("#saved-search-inner-items").prepend('<a href="' + searchUrl + '" class="dropdown-item">' + searchName + '</a>');

                    setTimeout(function () {
                        window.helpers.showNotification('Your search has been saved!', 'success');
                    }, 300);
                });
            }
        });


        /**
         * Initial Check on the URL Parameters Present
         */
        function checkInitialSearchParams() {

            if (window.helpers.includes(window.location.href, '?')) {

                if (urlSetState.length) {
                    locationSearchSelect.selectpicker('val', urlSetState.val());
                    locationSearchClearContainer.addClass('active');
                } else if (window.helpers.getQueryVariable('location')) {
                    var locationQuery = window.helpers.getQueryVariable('location');
                    var locationQuerySelected = decodeURIComponent(locationQuery).split(',');
                    locationSearchSelect.selectpicker('val', locationQuerySelected);
                    isFiltering = true;
                }

                if (window.helpers.getQueryVariable('price_max')) {
                    searchMaxPrice = window.helpers.getQueryVariable('price_max');
                    isFiltering = true;
                }

                if (window.helpers.getQueryVariable('price_min')) {
                    searchMinPrice = window.helpers.getQueryVariable('price_min');
                    isFiltering = true;
                }

                if (window.helpers.getQueryVariable('price_max') && window.helpers.getQueryVariable('price_min')) {
                    priceFilterLabel.html('$' + window.helpers.nFormatter(searchMinPrice, 1) + ' - ' + '$' + window.helpers.nFormatter(searchMaxPrice, 1));
                }

                if (window.helpers.getQueryVariable('acres_max')) {
                    searchMaxAcres = window.helpers.getQueryVariable('acres_max');
                    isFiltering = true;
                }

                if (window.helpers.getQueryVariable('acres_min')) {
                    searchMinAcres = window.helpers.getQueryVariable('acres_min');
                    isFiltering = true;
                }

                if (urlSetType.length) {
                    typeSearchSelect.selectpicker('val', urlSetType.val());
                } else if (window.helpers.getQueryVariable('property_types')) {
                    var propertyTypesQuery = window.helpers.getQueryVariable('property_types');
                    var propertyTypesQuerySelected = decodeURIComponent(propertyTypesQuery).split(',');
                    typeSearchSelect.selectpicker('val', propertyTypesQuerySelected);
                    isFiltering = true;
                }

                if (window.helpers.getQueryVariable('for_sale') && window.helpers.getQueryVariable('for_sale') === "yes") {
                    forSaleCheck.click();
                    isFiltering = true;
                }

                if (window.helpers.getQueryVariable('for_auction') && window.helpers.getQueryVariable('for_auction') === "yes") {
                    forAuctionCheck.click();
                    isFiltering = true;
                }

                if (window.helpers.getQueryVariable('is_sold') && window.helpers.getQueryVariable('is_sold') === "yes") {
                    soldCheck.click();
                    isFiltering = true;
                }

                if (window.helpers.getQueryVariable('past_auction') && window.helpers.getQueryVariable('past_auction') === "yes") {
                    pastAuctionCheck.click();
                    isFiltering = true;
                }

                if (window.helpers.getQueryVariable('recently_added_days')) {
                    recentlyAddedDaysCount = parseInt(window.helpers.getQueryVariable('recently_added_days'));
                    newPropertiesCheck.click();
                    isFiltering = true;
                }

                if (window.helpers.getQueryVariable('recently_reduced_days')) {
                    recentlyReducedDaysCount = parseInt(window.helpers.getQueryVariable('recently_reduced_days'));
                    recentlyReducedCheck.click();
                    isFiltering = true;
                }

                if (window.helpers.getQueryVariable('search_query')) {
                    searchQueryInput.val(decodeURIComponent(window.helpers.getQueryVariable('search_query')));
                    $('#primarySearch').val(decodeURIComponent(window.helpers.getQueryVariable('search_query')));
                    isFiltering = true;
                }

                if (window.helpers.getQueryVariable('search_property_name_query')) {
                    searchPropertyNameQueryInput.val(decodeURIComponent(window.helpers.getQueryVariable('search_property_name_query')));
                    $('#primarySearch').val(decodeURIComponent(window.helpers.getQueryVariable('search_property_name_query')));
                    isFiltering = true;
                }

                if(typeof window.is_custom_search !== 'undefined' && window.is_custom_search) {
                    $('#search-sort-button-price-high-to-low').click();
                } else {
                    if (window.helpers.getQueryVariable('sort_type')) {
                        var sortType = window.helpers.getQueryVariable('sort_type');
                        $('#search-sort-button-' + sortType).click();
                        setSortType = sortType;
                        isFiltering = true;
                    } else if (window.helpers.readCookie('user-last-set-sort-value')) {
                        let sortType = window.helpers.readCookie('user-last-set-sort-value');
                        if (isFiltering && sortType == "featured") {
                            $('#search-sort-button-price-high-to-low').click();
                        } else {
                            $('#search-sort-button-' + sortType).click();
                        }
                        setSortType = sortType;
                    } else {
                        // If no sort based on url param or cookie, trigger the "Featured" as the main sort option
                        if (isFiltering) {
                            $('#search-sort-button-price-high-to-low').click();
                        } else {
                            $('#search-sort-button-featured').click();
                        }
                    }
                }

                // If the view type has been set, check screen size and trigger if needed
                if (window.helpers.getQueryVariable('view_type') && window.helpers.getQueryVariable('view_type') === "map") {
                    if ($(window).width() > 1200) { triggerMapView(); } else { triggerMapView(); }
                }

                if (window.helpers.getQueryVariable('search_prices') === "no") {
                    showAnyPriceCheckbox.attr('checked', false);
                }

                if (window.helpers.getQueryVariable('search_acres') === "yes") {
                    acresSearchToggleCheckbox.attr('checked', true);
                    if (window.helpers.nFormatter(searchMaxAcres) === '50k') {
                        if (searchMinAcres === 0) {
                            acresFilterLabel.html('Any Acreage');
                        } else {
                            acresFilterLabel.html(window.helpers.nFormatter(searchMinAcres) + ' - ' + window.helpers.nFormatter(searchMaxAcres) + '+');
                        }
                    } else {
                        acresFilterLabel.html(window.helpers.nFormatter(searchMinAcres) + ' - ' + window.helpers.nFormatter(searchMaxAcres));
                    }
                }

                if (window.helpers.getQueryVariable('viewing_count')) {
                    viewingCount = parseInt(window.helpers.getQueryVariable('viewing_count'));
                }

                if (!isFiltering) {
                    window.helpers.eraseCookie('current_search_string');
                    forSaleCheck.click();
                    forAuctionCheck.click();
                }

            } else {

                if(typeof window.is_custom_search !== 'undefined' && window.is_custom_search) {
                    $('#search-sort-button-price-high-to-low').click();
                } else {
                    let sortTypeCookie = window.helpers.readCookie('user-last-set-sort-value');
                    if (sortTypeCookie) {
                        $('#search-sort-button-' + sortTypeCookie).click();
                    } else {
                        $('#search-sort-button-featured').click();
                    }
                }

            }

            propertySearch();
        }


        // Initial Search
        $('body').imagesLoaded(function () { matchImageHeights(); });
        $(window).on('resize', function () { matchImageHeights(); });


        function matchImageHeights() {
            var heightToSet = 0,
                items = $('.listing-img-container');

            items.css('height', '');
            items.each(function () {
                if (!$(this).hasClass('using-bg-image')) {
                    if ($(this).outerHeight() > heightToSet) heightToSet = $(this).outerHeight();
                }
            });
            items.css('height', heightToSet);
        }



        function fullSearchReset() {

            // All filtering status
            filtering.location = false;
            filtering.type = false;
            filtering.price = false;
            filtering.acreage = false;
            filtering.status.past_auction = false;
            filtering.status.for_auction = false;
            filtering.status.for_sale = false;
            filtering.status.sold = false;
            filtering.status.new = false;
            filtering.status.recent = false;
            filtering.status.reduced = false;

            forSaleCheck.attr('checked', false);
            window.helpers.updateUrl('for_sale', '');

            forAuctionCheck.attr('checked', false);
            window.helpers.updateUrl('for_auction', '');

            soldCheck.attr('checked', false);
            window.helpers.updateUrl('is_sold', '');

            pastAuctionCheck.attr('checked', false);
            window.helpers.updateUrl('past_auction', '');

            acresSearchToggleCheckbox.attr('checked', false);
            window.helpers.updateUrl('search_acres', '');

            searchQueryInput.val('');
            window.helpers.updateUrl('search_query', '');

            searchPropertyNameQueryInput.val('');
            window.helpers.updateUrl('search_property_name_query', '');

            acresSearchSlider.slider({
                values: [acresSearchLowInput.val(), acresSearchHighInput.val() + 100]
            });
            searchMinAcres = parseInt(acresSearchLowInput.val());
            searchMaxAcres = parseInt(acresSearchHighInput.val()) + 100;
            window.helpers.updateUrl('acres_min', '');
            window.helpers.updateUrl('acres_max', '');

            priceSearchSlider.slider({
                values: [0, parseInt(priceSearchHighInput.val()) + 100]
            });
            searchMinPrice = 0;
            searchMaxPrice = parseInt(priceSearchHighInput.val()) + 100;
            showAnyPriceCheckbox.attr('checked', true);
            priceFilterLabel.html('Any Price');

            locationSearchSelect.selectpicker('deselectAll');
            typeSearchSelect.selectpicker('deselectAll');

        }

        // Location Select Box - Change
        locationSearchSelect.on('change', function () {

            var showAll = false,
                selectRegion = false,
                region = '',
                regionCheck = '',
                values = locationSearchSelect.val();

            for (var key in values) {
                if (values.hasOwnProperty(key)) {
                    switch (values[key]) {
                        case "show-all": showAll = true; break;
                        case "Southeast": selectRegion = true; region = "southeast"; regionCheck = 'Southeast'; break;
                        case "Southwest": selectRegion = true; region = "southwest"; regionCheck = 'Southwest'; break;
                        case "Pacific": selectRegion = true; region = "pacific"; regionCheck = 'Pacific'; break;
                        case "Rocky Mountains": selectRegion = true; region = "rocky-mountains"; regionCheck = 'Rocky Mountains'; break;
                        case "Northeast": selectRegion = true; region = "northeast"; regionCheck = 'Northeast'; break;
                        case "Plains/Midwest": selectRegion = true; region = "plains-midwest"; regionCheck = 'Plains/Midwest'; break;
                        case "International": selectRegion = true; region = "international"; regionCheck = "International"; break;
                    }
                }
            }

            if (showAll) {
                locationSearchSelect.selectpicker('deselectAll');
                locationSearchClearContainer.removeClass('active');
                filtering.location = false;
            }

            // If selecting a region, loop through all and select within that region
            if (selectRegion) { $('a.opt.list-col-' + region).each(function () { $(this).click(); }); }

            if (locationSearchSelect.val() !== null && locationSearchSelect.val().length > 1) {
                filtering.location = true;
                var url = window.location.href;
                url = window.helpers.removeStateFromUrl(url);
                if (window.history.replaceState) { window.history.replaceState(null, null, url); }
            }

            if (locationSearchSelect.val() !== null && locationSearchSelect.val().length) {
                filtering.location = true;
                locationSearchClearContainer.addClass('active');
                $('.location-apply-button').removeClass('disabled');
            } else {
                filtering.location = false;
                locationSearchClearContainer.removeClass('active');
                $('.location-apply-button').addClass('disabled');
            }

            window.helpers.updateUrl('location', window.helpers.arrayToQueryString(locationSearchSelect.val(), ','));

            // Sets user's last location search selection
            window.helpers.createOrUpdateCookie('user-last-set-location', window.helpers.arrayToQueryString(locationSearchSelect.val(), ','), 60);

            if (initialSearchDone && !adjustingParams) propertySearch();
        });

        var typeSearchSelectedHasBeenFormatted = false;

        typeSearchSelect.on('shown.bs.select', function () {
            if (!typeSearchSelectedHasBeenFormatted) {
                if (typeSearchSelect.val() == null) {
                    $('#type-search-select-container').find('.inner').append('<div class="disabled type-apply-button">Search</div>');
                } else {
                    $('#type-search-select-container').find('.inner').append('<div class="type-apply-button">Search</div>');
                }

                typeSearchSelectedHasBeenFormatted = true;
            }
        });

        // Property Type Select Watcher
        typeSearchSelect.on('change', function () {
            var showAll = false,
                values = typeSearchSelect.val();

            for (var key in values) {
                if (values.hasOwnProperty(key)) {
                    if (values[key] === "show-all") { showAll = true; }
                }
            }

            if (showAll) {
                filtering.type = false;
                typeSearchSelect.selectpicker('deselectAll');
            }

            if (typeSearchSelect.val() !== null && typeSearchSelect.val().length > 1) {
                filtering.type = true;
                var url = window.location.href;
                url = window.helpers.removeTypeFromUrl(url);
                if (window.history.replaceState) { window.history.replaceState(null, null, url); }
            }

            if (typeSearchSelect.val() !== null && typeSearchSelect.val().length) {
                filtering.type = true;
                typeSearchClearContainer.addClass('active');
                $('.type-apply-button').removeClass('disabled');
            } else {
                filtering.type = false;
                typeSearchClearContainer.removeClass('active');
                $('.type-apply-button').addClass('disabled');
            }

            window.helpers.updateUrl('property_types', window.helpers.arrayToQueryString(typeSearchSelect.val(), ','));

            // Sets user's last type search selection
            window.helpers.createOrUpdateCookie('user-last-set-type', window.helpers.arrayToQueryString(typeSearchSelect.val(), ','), 60);

            if (initialSearchDone) propertySearch();
        });

        // For Sale Checkbox Watcher
        forSaleCheck.on('change', function () {
            if (forSaleCheck.is(":checked")) {
                window.helpers.updateUrl('for_sale', 'yes');
                window.helpers.createOrUpdateCookie('user-last-set-for-sale', 'yes', 60);
                filtering.status.for_sale = true;
            } else {
                window.helpers.updateUrl('for_sale', '');
                window.helpers.eraseCookie('user-last-set-for-sale');
                filtering.status.for_sale = false;
            }
            if (initialSearchDone && !adjustingParams) propertySearch();
        });

        // For Auction Checkbox Watcher
        forAuctionCheck.on('change', function () {
            if (forAuctionCheck.is(":checked")) {
                window.helpers.updateUrl('for_auction', 'yes');
                window.helpers.createOrUpdateCookie('user-last-set-for-auction', 'yes', 60);
                filtering.status.for_auction = true;
            } else {
                window.helpers.updateUrl('for_auction', '');
                window.helpers.eraseCookie('user-last-set-for-auction');
                filtering.status.for_auction = false;
            }
            if (initialSearchDone && !adjustingParams) propertySearch();
        });

        // Sold Checkbox Watcher
        soldCheck.on('change', function () {
            if (soldCheck.is(":checked")) {
                window.helpers.updateUrl('is_sold', 'yes');
                window.helpers.createOrUpdateCookie('user-last-set-is-sold', 'yes', 60);
                filtering.status.sold = true;
            } else {
                window.helpers.updateUrl('is_sold', '');
                window.helpers.eraseCookie('user-last-set-is-sold');
                filtering.status.sold = false;
            }
            if (initialSearchDone && !adjustingParams) propertySearch();
        });

        // Past Auction Checkbox Watcher
        pastAuctionCheck.on('change', function () {
            if (pastAuctionCheck.is(":checked")) {
                window.helpers.updateUrl('past_auction', 'yes');
                window.helpers.createOrUpdateCookie('user-last-set-past-auction', 'yes', 60);
                filtering.status.past_auction = true;
            } else {
                window.helpers.updateUrl('past_auction', '');
                window.helpers.eraseCookie('user-last-set-past-auction');
                filtering.status.past_auction = false;
            }
            if (initialSearchDone && !adjustingParams) propertySearch();
        });

        // New Properties Checkbox Watcher
        newPropertiesCheck.on('change', function () {
            if (newPropertiesCheck.is(':checked')) {
                if (recentlyAddedDaysCount === 0) {
                    window.helpers.updateUrl('recently_added_days', '90');
                    window.helpers.createOrUpdateCookie('user-last-set-recently-added-days', 90, 60);
                    recentlyAddedDaysCount = 90;
                    filtering.status.recent = true;
                } else {
                    window.helpers.updateUrl('recently_added_days', recentlyAddedDaysCount);
                    window.helpers.createOrUpdateCookie('user-last-set-recently-added-days', recentlyAddedDaysCount, 60);
                    filtering.status.recent = false;
                }
            } else {
                window.helpers.updateUrl('recently_added_days', '');
                recentlyAddedDaysCount = 0;
                window.helpers.eraseCookie('user-last-set-recently-added-days');
            }
            if (initialSearchDone) propertySearch();
        });

        // Recently Added Checkbox Watcher
        recentlyReducedCheck.on('change', function () {
            if (recentlyReducedCheck.is(':checked')) {
                if (recentlyReducedDaysCount === 0) {
                    window.helpers.updateUrl('recently_reduced_days', '90');
                    window.helpers.createOrUpdateCookie('user-last-set-recently-reduced-days', 90, 60);
                    recentlyReducedDaysCount = 90;
                } else {
                    window.helpers.updateUrl('recently_reduced_days', recentlyReducedDaysCount);
                    window.helpers.createOrUpdateCookie('user-last-set-recently-reduced-days', recentlyReducedDaysCount, 60);
                }
                filtering.status.reduced = true;
            } else {
                window.helpers.updateUrl('recently_reduced_days', '');
                recentlyReducedDaysCount = 0;
                window.helpers.eraseCookie('user-last-set-recently-reduced-days');
                filtering.status.reduced = false;
            }
            if (initialSearchDone) propertySearch();
        });

        // Search Input Query Watcher - NO LONGER IN USE
        searchQueryInput.on('keyup', function () {
            window.helpers.updateUrl('search_query', searchQueryInput.val());
            if (initialSearchDone) propertySearch();
        });

        // Main Search Input
        searchPropertyNameQueryInput.on('keyup', function () {
            window.helpers.updateUrl('search_property_name_query', searchPropertyNameQueryInput.val());
            if (initialSearchDone) propertySearch();
        });

        // Header Search Input that will update the SearchPropertyNameQueryInput value
        if ($('#header-search-form').length) {
            $("#primarySearch").on('keyup', function () {
                searchPropertyNameQueryInput.val($('#primarySearch').val());
                window.helpers.updateUrl('search_property_name_query', $('#primarySearch').val());

                if (initialSearchDone && $('#primarySearch').val().length > 3) {
                    propertySearch();
                }
            });

            $('#header-search-form').on('submit', function (e) {
                e.preventDefault();
                searchPropertyNameQueryInput.val($('#primarySearch').val());
                window.helpers.updateUrl('search_property_name_query', $('#primarySearch').val());
                if (initialSearchDone) {
                    propertySearch();
                }
            });
        }


        clearMoreOptionsButton.on('click', function () {
            filtering.location = false;
            filtering.type = false;
            filtering.price = false;
            filtering.acreage = false;
            filtering.status.past_auction = false;
            filtering.status.for_auction = false;
            filtering.status.for_sale = false;
            filtering.status.sold = false;
            filtering.status.new = false;
            filtering.status.recent = false;
            filtering.status.reduced = false;

            forSaleCheck.attr('checked', false);
            window.helpers.updateUrl('for_sale', '');
            forAuctionCheck.attr('checked', false);
            window.helpers.updateUrl('for_auction', '');
            soldCheck.attr('checked', false);
            window.helpers.updateUrl('is_sold', '');
            pastAuctionCheck.attr('checked', false);
            window.helpers.updateUrl('past_auction', '');
            acresSearchToggleCheckbox.attr('checked', false);
            window.helpers.updateUrl('search_acres', '');
            searchQueryInput.val('');
            window.helpers.updateUrl('search_query', '');
            searchPropertyNameQueryInput.val('');
            window.helpers.updateUrl('search_property_name_query', '');
            acresSearchSlider.slider({
                values: [acresSearchLowInput.val(), acresSearchHighInput.val() + 100]
            });
            searchMinAcres = parseInt(acresSearchLowInput.val());
            searchMaxAcres = parseInt(acresSearchHighInput.val()) + 100;
            window.helpers.updateUrl('acres_min', '');
            window.helpers.updateUrl('acres_max', '');
            $(this).addClass('d-none');
            propertySearch();
        });


        acresSearchToggleCheckbox.on('change', function () {

            if (acresSearchToggleCheckbox.is(':checked')) {
                window.helpers.updateUrl('search_acres', 'yes');
                window.helpers.createOrUpdateCookie('user-last-set-search-acres', 'yes', 60);
                if (window.helpers.nFormatter(searchMaxAcres) === '50k') {
                    if (searchMinAcres === 0) {
                        acresFilterLabel.html('Any Acreage');
                    } else {
                        acresFilterLabel.html(window.helpers.nFormatter(searchMinAcres) + ' - ' + window.helpers.nFormatter(searchMaxAcres) + '+');
                    }
                } else {
                    acresFilterLabel.html(window.helpers.nFormatter(searchMinAcres) + ' - ' + window.helpers.nFormatter(searchMaxAcres));
                }
            } else {
                window.helpers.updateUrl('search_acres', '');
                acresFilterLabel.html('Any Acreage');
                window.helpers.eraseCookie('user-last-set-search-acres');
                filtering.acreage = false;
            }

            if (initialSearchDone) propertySearch();
        });


        showAnyPriceCheckbox.on('change', function () {
            if (showAnyPriceCheckbox.is(':checked')) {
                filtering.price = false;
                priceFilterLabel.html('Any Price');

                window.helpers.updateUrl('search_prices', '');
                window.helpers.updateUrl('price_min', '');
                window.helpers.updateUrl('price_max', '');

                window.helpers.eraseCookie('user-last-set-search-prices');
                window.helpers.eraseCookie('user-last-set-price-min');
                window.helpers.eraseCookie('user-last-set-price-max');

                searchMinPrice = 0;
                searchMaxPrice = priceSearchHighInput.val();
                priceSearchSlider.slider({ values: [0, priceSearchHighInput.val()] });

            } else {

                filtering.price = true;
                window.helpers.updateUrl('search_prices', 'no');
                window.helpers.createOrUpdateCookie('user-last-set-search-prices', 'no', 60);

            }
            if (initialSearchDone) {
                propertySearch();
            }
        });

        // Sort Buttons Watcher
        searchSortButtons.on('click', function () {
            var sortType = $(this).data('sort-type'),
                sortLabel = $(this).html();

            setSortType = sortType;

            if (sortLabel === "Featured") { sortLabel = $(this).data('sort-label'); }
            if(sortType === "featured") {
                fullSearchReset();
                justSetToFeatured = true;
            }

            window.helpers.gaEvent('Property Search', 'sort-option-chosen', sortType);

            window.helpers.createOrUpdateCookie('user-last-set-sort-value', sortType, 60);

            sortingLabel.html(sortLabel);
            window.helpers.updateUrl('sort_type', sortType);

            $('.search-sort-button-mobile').not($('#search-sort-button-mobile-' + sortType)).removeClass('active');
            $('#search-sort-button-mobile-' + sortType).addClass('active');

            propertySearch();
        });

        morePropertiesButton.on('click', function () {
            viewingCount = viewingCount + viewingCountIncrement;

            window.helpers.updateUrl('viewing_count', viewingCount);

            propertySearch();
        });


        function clearMoreOptionsCheck() {
            if (forSaleCheck.is(':checked') ||
                forAuctionCheck.is(':checked') ||
                soldCheck.is(':checked') ||
                pastAuctionCheck.is(':checked') ||
                searchQueryInput.val().length > 0 ||
                searchPropertyNameQueryInput.val().length > 0 ||
                parseInt(searchMaxAcres) !== (parseInt(acresSearchHighInput.val()) + 100) ||
                parseInt(searchMinAcres) !== parseInt(acresSearchLowInput.val())
            ) {
                clearMoreOptionsButton.removeClass('d-none');
            } else {
                clearMoreOptionsButton.addClass('d-none');
            }
        }
        propertySearch();

        // Main Property Search
        function propertySearch() {

            isFiltering = (filtering.price ||
                filtering.acreage ||
                filtering.location ||
                filtering.type ||
                filtering.status.new ||
                filtering.status.sold ||
                filtering.status.for_sale ||
                filtering.status.for_auction ||
                filtering.status.past_auction ||
                filtering.status.recent ||
                filtering.status.reduced ||
                searchPropertyNameQueryInput.val().length > 0 ||
                searchQueryInput.val().length > 0
            );

            if(isFiltering && setSortType === "featured" && !justSetToFeatured) {
                $('#search-sort-button-price-high-to-low').click();
                propertySearch();
                return true;
            }
            if(justSetToFeatured) justSetToFeatured = false;

            if (window.defaultSortOrder !== "") window.helpers.gaEvent('Property-search', 'search-form-default-sort-order', window.defaultSortOrder);

            window.helpers.gaEvent('Property-search', 'search-form-submitted', '');

            if (!initialSearchDone) window.helpers.gaEvent('Property Search Debug', 'search-form-started', '');

            clearMoreOptionsCheck();

            var searchIndex = 0,
                totalResults = 0;

            var newCurrentProperties = [];

            var matchesSaleTypeObject = {
                'for_sale': (forSaleCheck.is(':checked')),
                'for_auction': (forAuctionCheck.is(':checked')),
                'sold': (soldCheck.is(':checked')),
                'past_auction': (pastAuctionCheck.is(':checked')),
                'new_properties': (newPropertiesCheck.is(':checked')),
                'recently_reduced': (recentlyReducedCheck.is(':checked')),
            };

            if (!matchesSaleTypeObject.for_sale &&
                !matchesSaleTypeObject.for_auction &&
                !matchesSaleTypeObject.sold &&
                !matchesSaleTypeObject.past_auction &&
                !matchesSaleTypeObject.new_properties &&
                !matchesSaleTypeObject.recently_reduced) {
                matchesSaleTypeObject.for_sale = true;
                matchesSaleTypeObject.for_auction = true;
            }

            var currentDate = new Date();

            // New Search Here
            $.post("/wp/wp-admin/admin-ajax.php", {
                'action': 'property_search',
                'year_pre_filter': (typeof window.year_pre_filter !== "undefined") ? window.year_pre_filter : '',
                'status_pre_filter': (typeof window.status_pre_filter !== "undefined") ? window.status_pre_filter : '',
                'locations': locationSearchSelect.val(),
                'types': typeSearchSelect.val(),
                'search': searchPropertyNameQueryInput.val(),
                'sale_type': matchesSaleTypeObject,
                'is_checking_acres': acresSearchToggleCheckbox.is(':checked'),
                'acres_max': searchMaxAcres,
                'acres_min': searchMinAcres,
                'is_showing_any_price': showAnyPriceCheckbox.is(':checked'),
                'price_max': searchMaxPrice,
                'price_min': searchMinPrice,
                'sort': setSortType,
                'viewing': viewingCount,
                'user_favorites': window.userFavorites,
                'recently_added_days': recentlyAddedDaysCount,
                'recently_reduced_days': recentlyReducedDaysCount
            }, function (response) {

                totalResults = response.data.total_results;
                searchIndex = response.data.total_results;
                propertyListingsContainer.html(response.data.results_html);
                mapProperties = response.data.map_properties;

                currentPropertiesId = newCurrentProperties;

                // Start: Low Result Check
                if(searchIndex < 8 && !window.year_pre_filter && !window.status_pre_filter) {

                    if((filtering.status.sold &&
                        filtering.status.for_sale &&
                        filtering.status.for_auction &&
                        filtering.status.past_auction) ||
                        searchPropertyNameQueryInput.val() !== '' ||
                        locationSearchSelect.val() === null
                    ) {
                        // DO NOTHING
                    } else {

                        if(
                            (pastAuctionCheck.is(':checked') && soldCheck.is(':checked') && forAuctionCheck.is(':checked') && forSaleCheck.is(':checked')) ||
                            (newPropertiesCheck.is(":checked") || recentlyReducedCheck.is(":checked"))
                        ) {
                            // DO NOTHING - All already checked, so this should avoid a recurring loop
                        } else {
                            adjustingParams = true;

                            if(!pastAuctionCheck.is(":checked")) pastAuctionCheck.click();

                            if(!soldCheck.is(":checked")) soldCheck.click();

                            if(!forAuctionCheck.is(":checked")) forAuctionCheck.click();

                            if(!forSaleCheck.is(":checked")) forSaleCheck.click();

                            setTimeout(function () {
                                adjustingParams = false;
                                propertySearch();
                            }, 300);

                            return false;
                        }
                    }
                }
                // End: Low Result Check


                if(setSortType === "featured") {
                    $("#property-count-label").html('16 Properties Selected <span class="property-count-secondary">out of ' + propertiesLength + ' Available</span>');
                    $("#property-count-label-mobile").html('16 Properties Selected <span class="property-count-secondary">out of ' + propertiesLength + ' Available</span>');
                } else {
                    if (searchIndex === 1) {
                        $("#property-count-label").html(searchIndex + ' Property Selected <span class="property-count-secondary">out of ' + propertiesLength + ' Available</span>');
                        $("#property-count-label-mobile").html(searchIndex + ' Property Selected <span class="property-count-secondary">out of ' + propertiesLength + ' Available</span>');
                    } else {
                        $("#property-count-label").html(searchIndex + ' Properties Selected <span class="property-count-secondary">out of ' + propertiesLength + ' Available</span>');
                        $("#property-count-label-mobile").html(searchIndex + ' Properties Selected <span class="property-count-secondary">out of ' + propertiesLength + ' Available</span>');
                    }
                }

                if (!initialSearchDone) {
                    window.helpers.gaEvent('Property Search Debug', 'search-form-completed', '');
                    window.helpers.gaEvent('Property Search Debug', 'search-form-completed-time', window.searchLoadTime);
                    clearInterval(window.searchLoadTimeInterval);

                    // initialSearchDone = true;
                    listingsViewLoading.addClass('overlay-hiding');
                    filterBarLoading.addClass('overlay-hiding');

                    setTimeout(function () {
                        listingsViewLoading.addClass('d-none');
                        filterBarLoading.addClass('d-none');
                    }, 350);

                    if (window.helpers.getQueryVariable('scroll_position')) {
                        $(window).scrollTop(window.helpers.getQueryVariable('scroll_position'));
                    }
                    initialSearchDone = true;
                }

                if (displayType.toString() === "map") setListingsMap();
                noListingsCheck(totalResults);
                filteringCheck(totalResults);
                moreButtonCheck(totalResults);

                lazyLoadPropertyImages();

            });
            // End New Search

        }


        function setListingsMap() {

            var locationsSelected = locationSearchSelect.val(),
                countOfLocations = 0,
                lastLocationSelected = '';

            for (var key2 in locationsSelected) {
                if (locationsSelected.hasOwnProperty(key2)) {
                    countOfLocations++;
                    lastLocationSelected = locationsSelected[key2];
                }
            }

            if (countOfLocations === 1 && lastLocationSelected !== '' && window.helpers.mapPositioningOptions.hasOwnProperty(lastLocationSelected)) {
                var zoom = window.helpers.mapPositioningOptions[lastLocationSelected].zoom,
                    lat = window.helpers.mapPositioningOptions[lastLocationSelected].lat,
                    long = window.helpers.mapPositioningOptions[lastLocationSelected].long,
                    windowWidth = $(window).width();

                if (windowWidth < 450) {
                    zoom = zoom - 1.8;
                } else if (windowWidth < 500) {
                    zoom = zoom - 1.5;
                } else if (windowWidth < 768) {
                    zoom = zoom - 1;
                } else if (windowWidth < 991) {
                    zoom = zoom - .8;
                } else if (windowWidth < 1200) {
                    zoom = zoom - .5;
                }

                var defaultMapOptions = {
                    center: { lat: lat, lng: long },
                    zoom: zoom,
                    mapTypeControl: false,
                    disableDefaultUI: true,
                    mapTypeId: 'terrain'
                };
            } else {
                var zoom = 5,
                    windowWidth = $(window).width();

                if (windowWidth < 450) {
                    zoom = 3.2;
                } else if (windowWidth < 500) {
                    zoom = 3.5;
                } else if (windowWidth < 768) {
                    zoom = 4;
                } else if (windowWidth < 991) {
                    zoom = 4.2;
                } else if (windowWidth < 1200) {
                    zoom = 4.5;
                }

                var defaultMapOptions = {
                    center: { lat: 39.8283, lng: -98.5795 },
                    zoom: zoom,
                    mapTypeControl: false,
                    disableDefaultUI: true,
                    mapTypeId: 'terrain'
                };
            }

            var map = new google.maps.Map(document.getElementById('property-map-object'), defaultMapOptions),
                bounds = new google.maps.LatLngBounds(),
                infoWindow = new google.maps.InfoWindow();

            map.setOptions({ styles: window.helpers.defaultGoogleMapStyles });

            for (var propId in mapProperties) {
                if (properties.hasOwnProperty(propId)) {
                    var property = properties[propId];
                    // if (property.showing) {

                        var icon = '';
                        if (property.is_auction === "true" && property.is_current_auction === "true") {
                            icon = '/assets/img/map-icons/auction-map-pin.png';
                        } else {
                            icon = '/assets/img/map-icons/normal-map-pin.png';
                        }

                        if (property.status === "Sold") {
                            icon = '/assets/img/map-icons/sold-map-pin.png';
                        }

                        var priceAuctionBlock = '',
                            viewLabel = '';

                        if (property.is_auction === "true") {
                            priceAuctionBlock = '<span class="listing-info">' + property.auction_formatted_date + '</span>';
                            viewLabel = "Auction";
                        } else {
                            priceAuctionBlock = '<span class="listing-info">$' + property.price.format() + '</span>';
                            viewLabel = "Property";
                        }

                        var status = '',
                            statusClass = '';

                        if (property.price_reduced_date !== "") {
                            status = 'Reduced';
                            statusClass = 'is-reduced';
                        } else if (property.is_auction === "true") {
                            if (property.is_current_auction === "true") {
                                status = 'Auction';
                                statusClass = 'is-auction';
                            } else {
                                status = 'Past Auction';
                                statusClass = 'is-past-auction';
                                icon = '/assets/img/map-icons/sold-map-pin.png';
                            }
                        } else if (property.status === "Sold") {
                            status = "Sold";
                            statusClass = 'is-past-auction';
                            icon = '/assets/img/map-icons/sold-map-pin.png';
                        }

                        var marker = new google.maps.Marker({
                            position: {
                                lat: parseFloat(property.latitude),
                                lng: parseFloat(property.longitude)
                            },
                            map: map,
                            title: property.title,
                            icon: icon
                        });

                        var statusContainer = '';
                        if (status !== "") {
                            statusContainer = '<span class="listing-label">' + status + '</span>';
                        }

                        var videoContainer = '';
                        if (property.has_videos == "true") {
                            videoContainer = '<a href="' + property.property_link + '?video=true" class="listing-video"><span class="sr-only">Play Video</span></a>';
                        }

                        var photosContainer = '';
                        if (property.image_count > 0) {
                            photosContainer = '<a href="' + property.property_link + '?gallery=true" class="listing-pictures">' + property.image_count + '</a>';
                        }

                        var isFavorite = false;
                        if (window.userFavorites !== undefined && window.userFavorites !== null) {
                            for (var i = 0; i < window.userFavorites.length; i++) {
                                if (window.userFavorites[i] === property.id) {
                                    isFavorite = true;
                                }
                            }
                        }

                        if ($('#current-user-id').val() !== undefined) {
                            var favoriteClass = (isFavorite) ? 'is-favorite' : '';
                            var favoriteContent = '<a class="listing-favorite map-listing-favorite user-is-logged-in ' + favoriteClass + '" data-property-id="' + property.id + '"><span class="sr-only">Add to favorites</span></a>';
                        } else {
                            var favoriteContent = '<a data-toggle="modal" data-target="#insiders-register-form" class="listing-favorite map-listing-favorite" data-property-id="' + property.id + '"><span class="sr-only">Add to favorites</span></a>';
                        }

                        var listingBody = property.ad_30_word,
                            trimmedlistingBody = listingBody.substring(0, 105);
                        var trimmedlistingBody = trimmedlistingBody.substr(0, Math.min(trimmedlistingBody.length, trimmedlistingBody.lastIndexOf(" ")));

                        var content = '' +
                            '<div class="property-item no-hover-for-map popup-inner-container ' + statusClass + '">' +
                            '<div class="popup-left-container">' +
                            '<div class="listing-img map-listing-img">' +
                            '<a href="' + property.property_link + '" class="map-listing-image" style="background-image:url(' + property.listing_image + ')"></a>' +
                            statusContainer + videoContainer + photosContainer + favoriteContent +
                            '</div>' +
                            '</div>' +
                            '<div class="popup-right-container listing-body for-map">' +
                            '<div class="listing-body-internal">' +
                            '<div class="listing-header">' +
                            '<a href="' + property.property_link + '"><h3 class="heading-tertiary">' + property.title + '</h3></a>' +
                            '<span class="heading-quaternary">' + property.city + ', ' + property.state + '</span>' +
                            '</div>' +
                            '<p class="listing-body-map-ad">' + trimmedlistingBody + ' ...</p>' +
                            '</div>' +
                            '<div class="listing-details row no-gutters">' +
                            '<div class="col"><div class="listing-size">' + property.deeded_acres.toLocaleString() + '± Deeded Acres</div></div>' +
                            '<div class="col text-right">' + priceAuctionBlock + '</div>' +
                            '</div>' +
                            '<a class="btn btn-secondary" href="' + property.property_link + '">View ' + viewLabel + ' Details</a>' +
                            '</div>' +
                            '</div>' +
                            '';

                        var infoWindowNew = new SnazzyInfoWindow({
                            marker: marker,
                            content: content,
                            closeWhenOthersOpen: true,
                            callbacks: {
                                afterOpen: function () {
                                    if ($(window).width() < 768) {
                                        $('#property-map-zoom-controls').addClass('d-none');
                                    }

                                    $('.map-listing-favorite').on('click', function () {

                                        if ($(this).data('toggle') === "modal") {
                                            var target = $(this).data('target');
                                            $(target).modal('show');
                                        } else {
                                            if ($(this).hasClass('user-is-logged-in')) {
                                                var selecting = (!$(this).hasClass('is-favorite')),
                                                    parent = $(this).parent().parent('.property-item');
                                                $(this).toggleClass('is-favorite');
                                                parent.toggleClass('is-favorite');

                                                var propertyId = $(this).data('property-id'),
                                                    userId = $('#current-user-id').val();

                                                var _this = $(this);

                                                $.post("/wp/wp-admin/admin-ajax.php", {
                                                    'action': 'favorite_property',
                                                    'property_id': propertyId,
                                                    'user_id': userId,
                                                    'mode': (selecting) ? 'select' : 'unselect'
                                                }, function (data) {
                                                    // If on the profile page, remove the favorite the page
                                                });
                                            }
                                        }

                                    });
                                }, afterClose: function () {
                                    if ($(window).width() < 768) {
                                        $('#property-map-zoom-controls').removeClass('d-none');
                                    }
                                }
                            }
                        });

                        // bounds.extend(marker.position);

                        google.maps.event.addListener(marker, 'click', (function (marker, content, infoWindow, infoWindowNew) {
                            return function () {
                                // infoWindowNew.close();
                                // infoWindow.close();
                                // infoWindow.setContent(content);
                                // infoWindow.open(map, marker);
                            }
                        })(marker, content, infoWindow, infoWindowNew));

                        google.maps.event.addListener(map, "click", function (event) {
                            infoWindow.close();
                            infoWindowNew.close();
                        });

                        console.log('We are here');

                        $('#property-map-object').on('click', function (e) { e.stopPropagation(); });

                        $('body').on('click', function () { infoWindow.close(); infoWindowNew.close(); });

                    // }
                }
            }

            $("#property-map-style-toggle").off();
            $("#property-map-style-toggle").on('click', function () {
                if ($(this).hasClass('is-satellite')) {
                    $(this).removeClass('is-satellite').addClass('is-terrain');
                    $(this).html('Switch to Satellite View');
                    map.setMapTypeId('terrain');
                } else if ($(this).hasClass('is-terrain')) {
                    $(this).addClass('is-satellite').removeClass('is-terrain');
                    $(this).html('Switch to Terrain View');
                    map.setMapTypeId('satellite');
                }
            });

            $('#property-map-zoom-in').off();
            $('#property-map-zoom-in').on('click', function () {map.setZoom(map.getZoom() + 1);});

            $('#property-map-zoom-out').off();
            $('#property-map-zoom-out').on('click', function () {map.setZoom(map.getZoom() - 1);});

        }


        // Check to see if there are no results and show the dialog if so
        function noListingsCheck(total) {
            if (total === 0) { noResultsContainer.removeClass('d-none'); } else { noResultsContainer.addClass('d-none'); }
        }


        // Check to see if we are filtering to show or hide the Reset and Save Search buttons
        function filteringCheck(total) {
            if (total === Object.keys(properties).length) {
                resetSearchNavItem.addClass('d-none');
                saveSearchNavItem.find('.save-btn').addClass('d-none');
                if ($(window).width() <= 1200) saveSearchNavItem.addClass('d-none');
            } else {
                resetSearchNavItem.removeClass('d-none');
                saveSearchNavItem.find('.save-btn').removeClass('d-none');
                if ($(window).width() <= 1200) saveSearchNavItem.removeClass('d-none');
            }
        }


        function moreButtonCheck(total) {
            if (viewingCount >= total) { morePropertiesButton.addClass('d-none'); } else { morePropertiesButton.removeClass('d-none'); }
        }


    }

    var listingBodies = $('.property-grid .property-item');

    // if (!$("#property-listings").length) {
    //
    //     $('.listing-image-container').each(function () {
    //
    //         let _this = $(this);
    //
    //         $(window).on('scroll', function () {
    //             if (isElementInViewport(_this)) {
    //                 if (!_this.hasClass('image-is-loaded')) {
    //                     console.log('Loading Image');
    //                     _this.find('img').attr('src', _this.data('image-to-load'));
    //                     _this.addClass('image-is-loaded');
    //                 }
    //             }
    //         });
    //
    //         // check to see if the item is in view and load image when it is
    //         if (isElementInViewport($(this))) {
    //             if (!$(this).hasClass('image-is-loaded')) {
    //                 console.log('Loading Image');
    //                 $(this).find('img').attr('src', $(this).data('image-to-load'));
    //                 $(this).addClass('image-is-loaded');
    //             }
    //         }
    //
    //     });
    //
    // }
});

function lazyLoadPropertyImages() {

    $('.listing-image-container').each(function () {

        if ($(this).hasClass('image-is-loaded') || $(this).hasClass('using-bg-image')) return;

        if (isElementInViewport($(this))) {
            console.log('Loading Image');
            $(this).find('img').attr('src', $(this).data('image-to-load'));
            $(this).addClass('image-is-loaded');
        }

    });

    return true;
}

lazyLoadPropertyImages();

$(window).on('scroll', function () {
    lazyLoadPropertyImages();
});

function isElementInViewport(el) {
    let rect = el[0].getBoundingClientRect();

    return rect.top < document.documentElement.clientHeight + 200;
}
